import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a warning outline icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <WarningOutlineIcon width={24} />
 */
const WarningOutlineIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M12,5.97L19.55,19L4.45,19L12,5.97 M12,3c-0.36,0-0.73,0.24-1,0.71L1.99,19.27c-0.55,0.95-0.1,1.73,1,1.73h18.03
	c1.1,0,1.55-0.78,1-1.73L13,3.71C12.73,3.24,12.36,3,12,3L12,3z M13,15.5h-2v2h2V15.5z M13,10.5c0-0.55-0.45-1-1-1l0,0
	c-0.55,0-1,0.45-1,1v2c0,0.55,0.45,1,1,1l0,0c0.55,0,1-0.45,1-1V10.5z"
        />
    </SvgIcon>
)

WarningOutlineIcon.defaultProps = defaultProps

export { WarningOutlineIcon }
